import Vue from 'vue';
import Vuex from 'vuex';
import TheGlobalLoader from '@/store/modules/TheGlobalLoader';
import TheGlobalSnackbar from '@/store/modules/TheGlobalSnackbar';
import TheLoggedUser from '@/store/modules/TheLoggedUser';

Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    TheLoggedUser,
    TheGlobalLoader,
    TheGlobalSnackbar,
  },
});

export default store;
